import { isEscape, returnFocus, trapFocus, throttle } from "./app/utils.js";

var returnFocusTo = window.returnFocusTo || null;
const breakpoints = {
    xs: 0,
    md: 768,
    lg: 1025,
    xl: 1536
};

/*
ADA
*/
document.body.addEventListener('keyup', e => {
    if (isEscape(e)) {
        // close things then return focus
        returnFocus();
    }
});
const isReduced = window.matchMedia(`(prefers-reduced-motion: reduce)`) === true || window.matchMedia(`(prefers-reduced-motion: reduce)`).matches === true;


/*
Mobile UI
*/


/*
Scroll events
*/
// window.addEventListener('scroll', throttle(100, function () {
//     if (window.scrollY > 50) {
//         document.body.classList.add('is-scrolled');
//         return;
//     }
//     document.body.classList.remove('is-scrolled');
// }));

import './app/primary-nav.js';
import './app/hero.js';
import './app/site-header.js';
import './app/popup.js';
import './app/header-cta-notice.js';
import './app/external-link-notice.js';
import './app/media-accordion.js';
